import { AsButton } from '@adserve/adserve-react-components';
import React, { useState, useEffect } from 'react';
import { invoiceDetailsButtonStyle } from './BillingStyles';
import TransactionItemDetails from './TransactionItemDetails';
import { GetInvoice } from '../../../services/CampaignsDataService';
import { sectionedPanelStyle } from '../CampaignStyles';

const InvoiceDetails = ({
    sourceName,
    payload,
    readOnly = false,
    setShowInvoiceDetails
}) => {
    const [accountName, setAccountName] = useState(sourceName);
    const [invoiceHeader, setInvoiceHeader] = useState(payload);
    const [invoice, setInvoice] = useState({});

    const loadData = () => {
        GetInvoice(invoiceHeader?.id).then((data) => {
            setInvoice(data);
        });
    };

    useEffect(() => {
        loadData();
    }, [invoiceHeader]);

    const handleBackClick = () => {
        setShowInvoiceDetails(false);
    };

    return (
        <div style={sectionedPanelStyle}>
            <div
                style={{
                    display: 'flex',
                    flexDirection: 'column'
                }}
            >
                <TransactionItemDetails
                    item={invoice}
                    sourceName={accountName}
                    title='Invoice'
                    refField='invoiceNo'
                    setShowInvoiceDetails={setShowInvoiceDetails}
                />
                <div
                    style={{
                        display: 'flex',
                        justifyContent: 'flex-end',
                        margin: '0px 18px 15px 0px'
                    }}
                >
                    <div>
                        <AsButton
                            style={invoiceDetailsButtonStyle}
                            handleClick={handleBackClick}
                        >
                            Back
                        </AsButton>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default InvoiceDetails;
